import type * as React from 'react';

export type CardType = Record<string, unknown>;

export const Card: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className = '',
  children,
  ...rest
}) => {
  return (
    <div
      className={`flex flex-col items-stretch lg:px-4 lg:max-w-lg w-full z-10 sm:justify-center gap-2 sm:gap-8 sm:bg-white ${className}`.trim()}
      {...rest}
    >
      {children}
    </div>
  );
};
